import { AmplitudeEventTypes } from '../integrations/amplitude/types'

export const TrackingEvent = AmplitudeEventTypes

export type LogEvent = (eventType: string, eventProperties?: object) => void
